import React, { useEffect, useState } from "react";
import {
	TextField,
	Button,
	Box,
	Grid,
	Typography,
	Switch,
	FormControlLabel,
	Container,
	Stack,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	OutlinedInput,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputText from "../../components/InputText";
import MuiPhoneNumber from "mui-phone-number";
import PhoneInput from "react-phone-input-2";
import { signUp } from "aws-amplify/auth";
import "react-phone-input-2/lib/material.css";
import { type } from "@testing-library/user-event/dist/type";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import { generateClient } from "aws-amplify/api";
import { createUserProfile } from "../../graphql/mutations";
import { isValidPhoneNumber } from "react-phone-number-input";
const validatePhoneNumber = (value) => {
	const phoneNumber = isValidPhoneNumber(`+${String(value)}`);
	console.log(phoneNumber, "phone number validation");
	if (!phoneNumber) {
		return false;
	} else if (phoneNumber === "TOO_SHORT" || phoneNumber === "TOO_LONG") {
		return false;
	}
	return phoneNumber;
};

function PhoneNumberInput({ formik }) {
	return (
		<Box sx={{ flexGrow: 1 }}>
			<label
				style={{
					margin: "10px 0px",
					display: "block",
					textWrap: "nowrap",
				}}
				htmlFor="phoneNumber"
			>
				Phone Number
				<span style={{ color: "red", marginLeft: "5px" }}>*</span>
			</label>

			<PhoneInput
				country="pk"
				value={formik.values.phoneNumber}
				inputProps={{
					name: "phoneNumber",
					"data-testid": "phone-input",
				}}
				inputStyle={{
					borderRadius: "30px",
					margin: 0,
					width: "100%",
					padding: "16.5px 14px 16.5px 58px",
					borderColor:
						formik.touched.phoneNumber && formik.errors.phoneNumber
							? "red"
							: "rgba(145, 158, 171, 0.24)",
					height: "56px",
				}}
				containerStyle={{ margin: 0 }}
				specialLabel=""
				onChange={(value, country) => {
					console.log("Value received:", value); // "923001234567"
					console.log("Country received:", country); // { dialCode: "92", name: "Pakistan", ... }

					formik.setFieldValue("phoneNumber", value); // Sets complete number

					formik.setFieldTouched("phoneNumber", false, false);
				}}
				onBlur={() => {
					formik.setFieldTouched("phoneNumber", true);
				}}
			/>
			{formik.touched.phoneNumber && formik.errors.phoneNumber && (
				<Typography sx={{ color: "red" }}>
					{formik.errors.phoneNumber}
				</Typography>
			)}
		</Box>
	);
}

const SignUpForm = () => {
	const client = generateClient();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const formik = useFormik({
		initialValues: {
			username: "",
			email: "",
			password: "",
			confirmPassword: "",
			companyName: "",
			phoneNumber: "",
			designation: "",
		},
		validationSchema: Yup.object({
			username: Yup.string().required("Name is required"),
			email: Yup.string()
				.email("Invalid email address")
				.required("Email is required"),
			password: Yup.string()
				.min(8, "Password must be at least 8 characters")
				.required("Password is required"),
			confirmPassword: Yup.string()
				.oneOf([Yup.ref("password"), null], "Passwords must match")
				.required("Confirm password is required"),
			companyName: Yup.string().required("Company name is required"),
			phoneNumber: Yup.string()
				.required("Phone number is required")
				.test("phone", "Invalid phone number", function (value) {
					return validatePhoneNumber(value);
				}),

			designation: Yup.string().required("Designation is required"),
		}),
		onSubmit: async (values) => {
			console.log("Form values:", values);
			try {
				setLoading(true);
				const response = await signUp({
					username: values.email,
					password: values.password,
					options: {
						userAttributes: {
							"custom:companyName": values.companyName,
							"custom:designation": values.designation,
							"custom:name": values.username,
							phone_number: `+${values.phoneNumber}`,
						},
					},
				});

				console.log(response, "signup_response");
				navigate(`/verify-email/${values.email}`);
			} catch (error) {
				toast.error(error.message);
				console.log(error.message);
			} finally {
				setLoading(false);
			}
		},
	});

	function camelCaseToCapitalized(str) {
		// Use a regular expression to insert a space before each uppercase letter
		const result = str.replace(/([a-z])([A-Z])/g, "$1 $2");

		// Capitalize the first letter of the result
		return result.charAt(0).toUpperCase() + result.slice(1);
	}

	console.log(formik, "formik");

	return (
		<Container
			component="main"
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "100vh",
			}}
		>
			<form onSubmit={formik.handleSubmit}>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						padding: 3,
						borderRadius: 2,
						boxShadow: 3,
						backgroundColor: "#fff",
						color: "#000",
						width: "100%",
						marginY: "auto",
					}}
				>
					<Stack
						direction={"row"}
						width={"100%"}
						justifyContent={"space-between"}
					>
						<Box>
							<img
								src="/assets/DreamStreamBlackLogo.svg"
								alt="DreamStream Logo"
								width={150}
								height={68}
							/>
							<Typography textAlign={"center"}>
								Magic in motion
							</Typography>
						</Box>

						<Typography textAlign={"center"}>
							Already have an account?
							<span style={{ marginLeft: 2 }}>
								<Link to={"/login"}>Login</Link>
							</span>
						</Typography>
					</Stack>

					<Typography variant="h5" component="h1" gutterBottom>
						Create an account
					</Typography>
					<Grid container spacing={2}>
						{Object.keys(formik.initialValues).map((field) => (
							<>
								{field === "phoneNumber" ? (
									<Grid item xs={12} sm={6}>
										<PhoneNumberInput formik={formik} />
									</Grid>
								) : field !== "countryCode" ? (
									<Grid item xs={12} sm={6}>
										<InputText
											formik={formik}
											label={
												field === "email"
													? "Official Email Address"
													: camelCaseToCapitalized(
															field
													  )
											}
											placeholder={`Enter ${camelCaseToCapitalized(
												field
											)}`}
											id={field}
											name={field}
											type={
												field === "password" ||
												field === "confirmPassword"
													? "password"
													: "text"
											}
											value={formik.values[field]}
										/>
									</Grid>
								) : null}
							</>
						))}
						<Grid alignSelf={"end"} item xs={12} sm={6}>
							<LoadingButton
								loading={loading}
								fullWidth
								sx={{
									padding: "16.5px 14px",
									"&:hover": {
										backgroundColor: "primary.darker", // Change the background color on hover
										color: "secondary.main", // Change the text color on hover
										borderColor: "primary.darker", // Change the border color on hover
									},
								}}
								type="submit"
								variant="outlined"
							>
								Sign Up
							</LoadingButton>
						</Grid>
					</Grid>
				</Box>
			</form>
		</Container>
	);
};

export default SignUpForm;
